export default {
  english: {
    breakingTitle: 'Breaking news',
    quickCategoryNav: 'Must see',
    metaDescription: 'i24NEWS brings you the biggest news and stories from the Middle East, Israel and around the world',
    title: 'i24NEWS - Breaking news from the Middle East, Israel and around the world',
    close: 'Close',
    link: {
      label: 'See more >>',
    },
  },
  french: {
    breakingTitle: 'Édition spéciale',
    quickCategoryNav: 'À voir',
    metaDescription: 'i24NEWS vous informe des dernières nouvelles sur le Moyen-Orient, Israël et le monde entier',
    title: 'i24NEWS - Toute l\'actualité du Moyen-Orient, d\'Israël et du monde entier',
    close: 'Fermer',
    link: {
      label: 'Voir plus >>',
    },
  },
  arabic: {
    breakingTitle: 'أخبار عاجلة',
    quickCategoryNav: 'يجب رؤيته',
    metaDescription: 'قناة i24NEWS تقدم لكم أهم الأخبار والقصص من الشرق الأوسط وإسرائيل ودول العالم',
    title: 'قناة i24NEWS تقدم لكم الأخبار العاجلة من الشرق الأوسط وإسرائيل ودول العالم',
    close: 'أغلق',
    link: {
      label: 'شاهد المزيد >>',
    },
  },
  hebrew: {
    breakingTitle: 'חדשות מתפרצות',
    quickCategoryNav: 'חובת צפייה',
    metaDescription: 'i24NEWS מביא לכם את החדשות והסיפורים הכי גדולים מהמזרח התיכון, מישראל ומסביב לעולם',
    title: 'i24NEWS - חדשות מתפרצות מהמזרח התיכון, ישראל ומסביב לעולם',
    close: 'סגור',
    link: {
      label: 'ראה עוד >>',
    },
  },
  persian: {
    breakingTitle: 'خبر فوری',
    quickCategoryNav: 'باید دید',
    metaDescription: 'i24NEWS بزرگترین اخبار و داستان ها را از خاورمیانه، اسرائیل و سراسر جهان برای شما به ارمغان می آورد',
    title: 'i24NEWS - اخبار فوری از خاورمیانه، اسرائیل و سراسر جهان',
    close: 'بستن',
    link: {
      label: 'بیشتر ببینید >>',
    },
  },
}
